import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InitialsIconComponent } from './initials-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [InitialsIconComponent],
  exports: [InitialsIconComponent],
})
export class InitialsIconModule {}
